import React from 'react';
import { Star, Quote } from 'lucide-react';
interface TestimonialProps {
  name: string;
  age: number;
  role: string;
  text: string;
}
export function TestimonialCard({
  name,
  age,
  role,
  text
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-amber-100 relative flex flex-col h-full" data-id="element-11">
      <Quote className="absolute top-4 right-4 w-8 h-8 text-amber-200 opacity-50" data-id="element-12" />

      <div className="flex mb-4" data-id="element-13">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-orange-400 fill-current" data-id="element-14" />)}
      </div>

      <p className="text-gray-700 mb-6 flex-grow italic leading-relaxed" data-id="element-15">
        "{text}"
      </p>

      <div className="mt-auto border-t border-gray-100 pt-4" data-id="element-16">
        <p className="font-bold text-teal-800" data-id="element-17">
          {name}, {age} años
        </p>
        <p className="text-sm text-teal-600 font-medium" data-id="element-18">{role}</p>
      </div>
    </div>;
}